import React from 'react';
import { Modal } from 'admin/components/Modal';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { colors, Button } from '@material-dev/thread';

const TOS_LINK = 'https://www.volusion.com/terms-of-service';
const ACCEPTABLE_USE_LINK = 'https://www.volusion.com/acceptable-use-policy';

const StyledModal = styled(Modal)`
  overflow: auto;
`;

const ModalContent = styled(Flex).attrs({
  flexDirection: 'column'
})`
  padding: 16px;
  font-size: 16px;
  color: ${colors.black54};
  width: 100%;
  max-width: 400px;
`;

const A = styled.a`
  color: ${colors.primaryOrange};

  &:visited,
  &:hover {
    color: ${colors.primaryOrange};
  }
`;

const P = styled.p`
  padding: 0 0 16px;
`;

const TermsAndConditionsModal = (props) => {
  return (
    <StyledModal open={props.open} container={props.container}>
      <ModalContent>
        <Box>
          <P>
            <span>We have updated our </span>
            <A href={TOS_LINK} target="tos">Terms of Service</A>
            <span> which incorporates our </span>
            <A href={ACCEPTABLE_USE_LINK} target="tos">
              Acceptable Use Policy and Privacy Policy
            </A>
            <span> (collectively &ldquo;Terms&rdquo;). Please review each one carefully.</span>
          </P>
          <P>
            After reviewing the updates, click &ldquo;Agree&rdquo; below to proceed to your admin.
          </P>
        </Box>

        <Button onClick={props.onAccept} variant="primary">Agree</Button>
      </ModalContent>
    </StyledModal>
  );
};

TermsAndConditionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default TermsAndConditionsModal;


// WEBPACK FOOTER //
// ./src/app/admin/components/TermsAndConditionsModal/index.js